// removed by extract-text-webpack-plugin
module.exports = {"container":"ConnectionView__container___1gZ_2"};